import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


import { AuthService } from '@app/services/auth.service';

@Injectable()
export class CanActivateViaAuthGuard  {

  constructor(
        private router: Router,
        private authService: AuthService) { }

  canActivate(): boolean {
    const token = this.authService.authToken();
    if (!token) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
